// extracted by mini-css-extract-plugin
export default {"section":"Tr-z","sectionTitle":"Ur-z","fieldWrapper":"Vr-z","formField":"Wr-z","disabled":"Xr-z","formLabel":"Yr-z"};